/*
These functions make sure WordPress
and Foundation play nice together.
*/
(function($) {
    function scrollToTop(_top){
        var height = $(".tabs-wrapper").height();
        // +57 accounting for sticky search bar at the top of the page
        var _offset = height + 57;
        setTimeout(function(){
            jQuery('html,body').animate({
                scrollTop: _top - _offset
            }, 'slow');
        }, 1);
    }
    $(document).foundation();

    $(document).ready(function() {
        // Remove empty P tags created by WP inside of Accordion and Orbit
        $('.accordion p:empty, .orbit p:empty').remove();
    });
    
    $(window).on('load', function() {
        var hash = false;
        if(window.location.hash){
            $('.accordion-item a', '.service-items').each(function(){
                hash = '#' + $(this).attr('href').split('#')[1];
                if(hash && hash == window.location.hash){
                    var _parent = hash.split("_")[0];
                    $('#service-tabs').foundation('selectTab', $(_parent), true);
                    $('#service-tabs').animate({scrollLeft: $(_parent + "-label").position().left}, 30);

                    if ($(hash+"-label").length > 0){
                        var _scrollTop = $(hash+"-label").last().offset().top;
                        scrollToTop(_scrollTop);
                    }
                }

            });    
        }
        /*
        * A fix for links within foundation tabs not switching tab correctly.
        * May not be the correct way to do it but it works so...
        */
        $('.accordion-content a').each(function(){
            var hash = $(this).attr('href').split('#')[1];
            if(hash){
                var _parent = hash.split("_")[0];
                if(_parent){
                    $(this).click(function(){
                        $('#service-tabs').foundation('selectTab', _parent, true);
                        var label = '#'+hash+'-label';
                        if (label.length > 0){
                            var _scrollTop = $(label).last().offset().top;
                            scrollToTop(_scrollTop);
                        }
                    });
                }
            }
        });

        $('.tabs-panel').each(function(){
            $(this).css("display", "");
        });
    });
})( jQuery );